Ext.define('SA.view.menu.RemoveLocation', {
    alias: 'widget.menu-remove-location',
    extend: 'Ext.menu.Item',

    text: 'Remove from this Report',

    handler() {
        var view = this.view;

        view.removeLocation(this.location);
        view.save();
    }
});